// extracted by mini-css-extract-plugin
export var albums = "index-module--albums--2zV7-";
export var hacksContent = "index-module--hacksContent--2U75s";
export var hacks = "index-module--hacks--2a9N1";
export var albumsList = "index-module--albumsList--11m-c";
export var albumsListContents = "index-module--albumsListContents--766qg";
export var active = "index-module--active--ABbqO";